<template>
  <section>
    <form action v-on:submit.prevent="EditDistribution">
      <div class="modal-card">
        <header class="modal-card-head">
          <p>Editar Distribución</p>
        </header>
        <section class="modal-card-body">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
          <b-field label="Nombre" :label-position="'on-border'">
            <b-input v-model="distribution.name" required></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$parent.close()">
            Cerrar
          </button>
          <button class="button is-primary" type="submit">Guardar</button>
        </footer>
      </div>
    </form>
  </section>
</template>
<script>
import { DistributionService } from "../../../../services/models/distribution";

export default {
  props: ["id", "chargeListDistributions"],
  data() {
    return {
      distribution: {
        name: "",
      },
      isLoading: false,
    };
  },
  mounted(){
      this.chargeData();
  },
  methods: {
    async chargeData() {
      this.isLoading = true;
      try {
        const { data: distribution } = await DistributionService.getById(
          this.id
        );
        this.distribution = distribution;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.$buefy.notification.open({
          message: "Error al cargar datos!",
          type: "is-danger",
        });
      }
    },
    async EditDistribution() {
      this.isLoading = true;
      try {
        await DistributionService.update(this.id,this.distribution);
        this.$buefy.notification.open({
          message: "Distribución Editada!",
          type: "is-success",
        });
        this.chargeListDistributions();
        this.isLoading = false;
        this.$parent.close();
      } catch (error) {
        this.isLoading = false;
        this.$buefy.notification.open({
          message: "Error al editar distribución!",
          type: "is-danger",
        });
      }
    },
  },
};
</script>